import type { Cart } from './cart';
import { data, find } from './dom';

// Dugme koje šalje formu koraka porudžbine, dok se čeka odgovor servera (pregled i slanje traju i nekoliko sekundi).
interface SubmitButton {
  // Dugme ne radi ponovo, a natpis ostaje (forma ide negde drugde, npr. „Izmeni“ na pregledu).
  disable(): void;
  // Dugme ne radi ponovo i kaže šta se čeka (data-sending); isti tekst čitač ekrana čuje iz statusa.
  showSending(): void;
}

// Korak 1 porudžbine: spisak iz korpe (isti tekst kao u poruci) i skriveno polje sa korpom, koju server proverava i pretvara
// u stavke porudžbine. Bez skripte ili sa praznom korpom forma ostaje skrivena, a vidi se poruka sa linkovima i telefonom.
// Spisak se crta ponovo kad se korpa zatvori, jer kupac u njoj može da ukloni stavku. Dok se čeka pregled, „Dalje“ to kaže.
export function enhanceOrderForm(cart: Cart): void {
  const form = document.querySelector('[data-js="order-form"]');
  if (!(form instanceof HTMLFormElement)) return;

  const list = find(document, 'order-items', HTMLUListElement);
  const empty = find(document, 'order-empty', HTMLElement);
  const field = find(form, 'order-cart', HTMLInputElement);
  const next = submitButton(find(form, 'order-next', HTMLButtonElement), find(form, 'order-sending', HTMLElement));

  const item = (text: string): HTMLLIElement => {
    const element = document.createElement('li');
    element.className = 'order-cart__item';
    element.textContent = text;
    return element;
  };

  const draw = (): void => {
    const lines = cart.lines();
    list.replaceChildren(...lines.map(item));
    list.hidden = lines.length === 0;
    empty.hidden = lines.length > 0;
    form.hidden = lines.length === 0;
    field.value = cart.json();
  };

  $(form).on('submit', () => next.showSending());
  $(find(document, 'cart', HTMLDialogElement)).on('close', draw);
  draw();
  focusNotice();
}

// Pregled: dugme za slanje radi jednom, da dvostruki dodir ne pošalje dve porudžbine, i kaže da se porudžbina šalje; svako
// slanje forme (i „Izmeni“) ga onemogući. Korpa izmenjena u fioci traži novi pregled (data-refresh), jer cene i ukupno moraju
// da važe za ono što se šalje: forma ide na pregled sa novom korpom i istim podacima kupca, a dok se porudžbina šalje, fioka
// ne traži novi pregled.
export function enhanceOrderReview(cart: Cart): void {
  const form = document.querySelector('[data-js="order-review"]');
  if (!(form instanceof HTMLFormElement)) return;

  const sendButton = find(form, 'order-send', HTMLButtonElement);
  const send = submitButton(sendButton, find(form, 'order-sending', HTMLElement));
  const field = find(form, 'order-cart', HTMLInputElement);
  const reviewed = cart.json();
  // Pregledač bez SubmitEvent.submitter (stariji Safari) samo onemogući dugme, bez natpisa.
  $(form).on('submit', event => {
    const submitted = event.originalEvent;
    if (submitted !== undefined && 'submitter' in submitted && submitted.submitter === sendButton) send.showSending();
    else send.disable();
  });
  $(find(document, 'cart', HTMLDialogElement)).on('close', () => {
    if (sendButton.disabled || cart.json() === reviewed) return;
    field.value = cart.json();
    form.action = data(form, 'refresh');
    send.disable();
    form.submit();
  });
  focusNotice();
}

// Stranica potvrde: porudžbina je poslata, pa se korpa prazni.
export function clearOrderedCart(cart: Cart): void {
  if (document.querySelector('[data-js="order-received"]') !== null) cart.clear();
}

// Stranica vraćena iz istorije pregledača (bfcache) ponovo ima prvobitan natpis i dugme koje radi. Događaj pageshow pri prvom
// učitavanju se zanemaruje, jer bi vratio dugme koje je kupac dodirnuo pre kraja učitavanja, dok se forma još šalje.
function submitButton(button: HTMLButtonElement, status: HTMLElement): SubmitButton {
  const label = button.textContent ?? '';
  const sending = data(button, 'sending');
  $(window).on('pageshow', event => {
    if (!(event.originalEvent instanceof PageTransitionEvent) || !event.originalEvent.persisted) return;
    button.disabled = false;
    button.textContent = label;
    status.textContent = '';
  });

  return {
    disable() {
      button.disabled = true;
    },
    showSending() {
      button.disabled = true;
      button.textContent = sending;
      status.textContent = sending;
    },
  };
}

// Poruka iznad forme (greške, API koji ne odgovara, izmenjen pregled) dobija fokus, da je čitač ekrana pročita odmah, a
// kupac koji koristi tastaturu krene od nje.
function focusNotice(): void {
  const notice = document.querySelector('[data-js="order-notice"]');
  if (notice instanceof HTMLElement) notice.focus();
}
